import Comments from 'components/Comments';
import type { KeyValueCallback } from 'types/utils.type';
import type { TRelationType } from '@timeedit/types';
import GeneralInfo from './sections/GeneralInfo';
import Properties from './sections/Properties';
import './RelationType.scss';

interface FieldRelationProps {
  relationType?: TRelationType;
  onChange: KeyValueCallback<TRelationType>;
}

const FieldRelation = (props: FieldRelationProps) => {
  const { relationType, onChange } = props;
  if (!relationType) return null;
  return (
    <div className="field-relations">
      <GeneralInfo relationType={relationType} onChange={onChange} />
      <Properties relationType={relationType} onChange={onChange} />
      <Comments
        value={relationType.description}
        onChange={(val) => onChange('description', val)}
      />
    </div>
  );
};

export default FieldRelation;
